import React from "react"

import ErrorBoundary from "components/error-boundary"
import CTAButton from "../cta"
import { AffirmContainer, DiscountContainer } from "./styles"

const AffirmScript = React.lazy(() => import("components/common/affirm-script"))

const BuyButton = ({
  disclaimer,
  discountText,
  disclaimerText,
  price,
  showInstallmentPaymentLanguage,
  ...props
}) => (
  <DiscountContainer>
    <CTAButton {...props} />
    {discountText && <h4 dangerouslySetInnerHTML={{ __html: discountText }} />}
    {disclaimerText && <div dangerouslySetInnerHTML={{ __html: disclaimerText }} />}
    {showInstallmentPaymentLanguage && (
      <AffirmContainer>
        <ErrorBoundary componentType="AffirmScript">
          <React.Suspense>
            <AffirmScript />
          </React.Suspense>
        </ErrorBoundary>
        <p
          className="affirm-as-low-as"
          data-page-type="payment"
          data-amount={price ? price * 100 : null}
        />
      </AffirmContainer>
    )}
  </DiscountContainer>
)
export default BuyButton
